import React from 'react';
import MaterialList from '../../components/materials/MaterialList';

const Materials: React.FC = () => {

    return (<div>
        <MaterialList />
    </div>)
};

export default Materials;